import { z } from "zod";
import { multiSelectResponseSchema } from "../../common/schemaHelper";

/**
 * Weight Treatment History validation schema
 * Validates the entire weightTreatmentHistory category
 */

export const medicationsWithSideEffectsSchema = multiSelectResponseSchema.extend({
  sideEffects: z.string().optional(),
});

export const weightTreatmentHistoryValidation = z.object({
  medications: z.array(medicationsWithSideEffectsSchema).min(1, "Please select at least one option"),
  lifestylePrograms: z.array(multiSelectResponseSchema).min(1, "Please select at least one option"),
  priorSurgeriesOrProcedures: z.array(z.string()).min(1, "Please select at least one option"),
  logging: z.array(multiSelectResponseSchema).min(1, "Please select at least one option"),
});

export default weightTreatmentHistoryValidation;